import React from 'react';

import {getLegacyRequestObjectName} from 'requests/RequestConstants';
import * as RequestTaskSchemaDAO from 'requests/schemas/RequestTaskSchemaDAO';
import {ASSAY_TYPES} from 'results/assay-schemas/AssaySchemaConstants';
import * as AssaySchemaDAO from 'results/assay-schemas/AssaySchemaDAO';

import EmptySidebarIcon from './EmptySidebarIcon';
import {Section, SettingsSection} from './SidebarConstants';
import SidebarItem from './SidebarItem';

export interface RequestSchemaSettingsProps {
  section: SettingsSection;
}

export default function RequestSchemaSettings({section}: RequestSchemaSettingsProps): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">{`${getLegacyRequestObjectName({capwords: true})} Schemas`}</div>
      <SidebarItem
        active={section === Section.REQUEST_SCHEMAS}
        icon={<EmptySidebarIcon />}
        name={`${getLegacyRequestObjectName()} schemas`}
        link={AssaySchemaDAO.assaySchemasURL(ASSAY_TYPES.ASSAY_REQUEST)}
      />
      <SidebarItem
        active={section === Section.REQUEST_TASK_SCHEMAS}
        icon={<EmptySidebarIcon />}
        name="Task schemas"
        link={RequestTaskSchemaDAO.taskSchemaListingURL()}
      />
    </div>
  );
}
